import { MenuItemGroup, MenuLinkItem } from '@creditornot/cb-menu';
import React, { useState } from 'react';
import { FormattedMessage } from 'react-intl';

import { LanguageSelector } from 'common/components';
import { getLanguage } from 'locale';
import { UiLanguageKey } from 'locale/languages';

type Props = {
  className?: string;
  onChange?: (key: UiLanguageKey) => void;
};

const LanguageSelectorMenuItemGroup = ({ className, onChange }: Props) => {
  const currentLanguage = getLanguage();
  const [isShowingLanguages, setIsShowingLanguages] = useState(false);

  const handleLanguageSelect = (key: UiLanguageKey) => {
    setIsShowingLanguages(false);
    onChange?.(key);
  };

  return (
    <MenuItemGroup
      className={className}
      title={<FormattedMessage id={isShowingLanguages ? 'navigation.languages' : 'navigation.language'} />}
    >
      {isShowingLanguages ? (
        <LanguageSelector onLanguageSelect={handleLanguageSelect} />
      ) : (
        <MenuLinkItem onClick={() => setIsShowingLanguages(true)}>{currentLanguage.label}</MenuLinkItem>
      )}
    </MenuItemGroup>
  );
};

export default LanguageSelectorMenuItemGroup;
